
  <div class="flex flex-column justify-content-center align-items-center">
  <div class="container-nave">
  <span class="material-symbols-outlined" style="color: #6da043;" *ngIf="type === 0">directions_boat</span>
  <span class="material-symbols-outlined" style="color: #6da043;" *ngIf="type === 1">flight</span>
  <span class="material-symbols-outlined" style="color: #6da043;" *ngIf="type === 2">local_shipping</span>
  <span class="material-symbols-outlined" style="color: #6da043;">arrow_forward_ios</span>
  </div>
  <div *ngIf="ship" class="flex">
      <span class="text-center" style="font-size: small;">{{ ship }}</span>
  </div>
  </div>

